module.exports = __webpack_public_path__ + "static/media/metalprocessing.e8e21803.png";